import React from 'react'
import { useDispatch } from 'react-redux'
import {
  setConfirmCompanyRequestModalVisibility as setConfirmCompanyRequestModalVisibilityAction,
  setMergeCompanyRequestModalVisibility as setMergeCompanyRequestModalVisibilityAction,
} from '../../slices/company_request_slice'
import ConfirmCompanyForm from './ConfirmCompanyForm'

export default function ConfirmCompanyModalContent({ formId = 'confirm_company', company, onBack, onNext }) {
  const dispatch = useDispatch()

  const handleClickMergeButton = () => {
    dispatch(setConfirmCompanyRequestModalVisibilityAction(false))
    dispatch(setMergeCompanyRequestModalVisibilityAction(true))
  }

  return (
    <>
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content new-brp-modal">
          <div className="modal-header">
            <div className="dome-h2 dome-color-dark-grey">Confirm Company</div>
          </div>
          <div className="modal-body">
            <ConfirmCompanyForm id={formId} company={company} onSubmit={onNext} />
          </div>
          <div className="modal-footer">
            <button
              className="dome-btn dome-btn-link dome-btn-link-cancel pull-left dome-color-med-grey"
              data-dismiss="modal"
              onClick={onBack}
            >
              cancel
            </button>
            <div className="dome-d-flex dome-gap12 pull-right">
              <button
                type="button"
                className="dome-btn dome-btn-base dome-btn-green-stroke"
                onClick={handleClickMergeButton}
              >
                I want to merge
              </button>
              <button type="submit" form={formId} className="dome-btn dome-btn-base dome-btn-aqua-stroke">
                confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
